import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { PinDropIcon } from '../SharedComponents/Icons';
import LocationAddedMessage from '../OrderForm/LocationAddedMessage';

class OrderFormTrigger extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showLocationMessageModal: false,
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleShowMessageModal = this.handleShowMessageModal.bind(this);
    this.handleCloseMessageModal = this.handleCloseMessageModal.bind(this);
  }

  componentDidUpdate(prevProps) {
    const selectedLocationsLength = this.props.selectedLocations && this.props.selectedLocations.length;

    if (selectedLocationsLength && selectedLocationsLength > prevProps.selectedLocations.length) {
      this.handleShowMessageModal();
    }
  }

  handleClick() {
    this.props.onClick();
  }

  handleShowMessageModal() {
    this.setState({ showLocationMessageModal: true });
    setTimeout(this.handleCloseMessageModal, 4000);
  }

  handleCloseMessageModal() {
    this.setState({ showLocationMessageModal: false });
  }

  render() {
    return (
      <span
        className="order-form__counter-wrap"
        onClick={this.handleClick}
        onKeyPress={() => {}}
        role="button"
        tabIndex="0"
      >
        {this.props.selectedLocations.length > 0 && (
          <span className="order-form__counter">{this.props.selectedLocations.length}</span>
        )}
        <PinDropIcon />
        { this.state.showLocationMessageModal
        && (
          <LocationAddedMessage
            locationsCount={this.props.selectedLocations.length}
            seeAllLocations={this.handleClick}
            handleCloseMessageModal={this.handleCloseMessageModal}
          />
        )
        }
      </span>
    );
  }
}

OrderFormTrigger.propTypes = {
  onClick: PropTypes.func,
  selectedLocations: PropTypes.arrayOf(PropTypes.object),
};

OrderFormTrigger.defaultProps = {
  onClick: () => true,
  selectedLocations: [],
};

export default OrderFormTrigger;
